<template>
  <div v-if="dataIsLoaded">
    <router-view/>
  </div>
  <div v-else>
    <LoadingComponent />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import LoadingComponent from '@/components/LoadingComponent.vue';

  export default {
    name: "App",
    components: {
      LoadingComponent,
    },
    data() {
      return {
        dataIsLoaded: false,
      }
    },
    computed: {
      ...mapState(["companyID", "role", "companyData", "profileData"]),
    },
    methods: {
      autoAdjustViewportScale() {
        if (window.innerWidth >= 1440) {
          return;
        }
        let viewport = document.querySelector("meta[name=viewport]");
        if (!viewport) {
            viewport = document.createElement("meta");
            viewport.name = "viewport";
            document.head.appendChild(viewport);
        }

        let screenWidth = window.innerWidth;
        let designWidth = 1440;

        let scale = screenWidth / designWidth;

        viewport.content = `width=${designWidth}, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`;
      },
      async loadData() {
        const routingName = this.$route.name;
        const unauthorizedAccessUrls = ["sign-up", "sign-in", "account-confirmation", "reset-password", "reset-phone", "reset-email-continue", "reset-email-final"];
        const notRedirectingToRoleUrls = ["account-confirmation", "reset-password", "reset-phone", "reset-email-continue", "reset-email-final"];
        this.$store.dispatch("updateCurrentSchedulePeriod", {date: this.$globalMethods.getFirstDayOfCurrentMonth(), verbose: this.$globalMethods.getCurrentMonthAndYear()});

        let result = await this.$store.dispatch("fetchCSRFToken");
        if (!result.successfully) { 
          return;
        }
        
        result = await this.$store.dispatch('fetchCheckAuthentication');
        if (!notRedirectingToRoleUrls.includes(routingName) && result.successfully) {
          result = await this.$store.dispatch("fetchProfileData");
          if (this.role === "founder") {
              let result = await this.$store.dispatch("fetchCompanyData");
              if (result.detail === "redirect_to_choose_role") {
                this.$router.push({name: "role"})
              }
              if (this.companyID) { 
                result = await this.$store.dispatch("fetchKassas"); 
                if (result.successfully) { result = await this.$store.dispatch("fetchClients"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchGoods"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchSupplyingsAndMovings"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchStaffs"); }
                if (this.companyData.plan.schedule_and_salary_plugin_is_active) {
                  if (result.successfully) { result = await this.$store.dispatch("fetchSchedules", {dateFrom: this.$globalMethods.getFirstDayOfCurrentMonth(), dateTo: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                  if (result.successfully) { result = await this.$store.dispatch("fetchPayouts", {targetPeriod: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                  if (result.successfully) { result = await this.$store.dispatch("fetchSalaryReports", this.$globalMethods.getFirstDayOfCurrentMonth()); }
                }
                if (result.successfully && this.profileData.email === this.companyData.founder.email && routingName === "create-company") {
                  this.$router.push({name: "dashboard"});
                }
                this.dataIsLoaded = true;
              } else {
                this.dataIsLoaded = true;
                this.$router.push({name: "create-company"});
              }
          } else if (this.role === "staff") {
            let result = {successfully: true};
            if (this.companyID) { 
              result = await this.$store.dispatch("fetchCompanyData"); 
              if (result.detail === "redirect_to_choose_role" || !this.companyData) {
                this.$router.push({name: "role"})
              }
              if (result.successfully) { result = await this.$store.dispatch("fetchPersonalStaffData"); }
              if (result.successfully) { result = await this.$store.dispatch("fetchKassas"); }
              if (result.successfully) { result = await this.$store.dispatch("fetchClients"); }
              if (result.successfully) { result = await this.$store.dispatch("fetchGoods"); }
              if (result.successfully) { result = await this.$store.dispatch("fetchSupplyingsAndMovings"); }
              if (this.companyData && this.companyData.plan.schedule_and_salary_plugin_is_active) {
                  if (result.successfully) { result = await this.$store.dispatch("fetchStaffs"); }
                  if (result.successfully) { result = await this.$store.dispatch("fetchSchedules", {dateFrom: this.$globalMethods.getFirstDayOfCurrentMonth(), dateTo: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                  if (result.successfully) { result = await this.$store.dispatch("fetchPayouts", {targetPeriod: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                  if (result.successfully) { result = await this.$store.dispatch("fetchSalaryReports", this.$globalMethods.getFirstDayOfCurrentMonth()); }
              }
            }
            if (result.successfully) {result = await this.$store.dispatch("fetchAvailableCompanies");}
            if (result.successfully) {this.dataIsLoaded = true;}
          } else if (routingName !== "role") {
            this.dataIsLoaded = true;
            this.$router.push({name: "role"});
          }
        } else if (!unauthorizedAccessUrls.includes(routingName)) {
          this.dataIsLoaded = true;
          this.$router.push({ name: 'sign-in' }); 
        }
        this.dataIsLoaded = true; 
      },
    },
    async mounted() {
      this.autoAdjustViewportScale();
      setTimeout(async () => {
        await this.loadData();
      }, 100)
    },
  }
</script>
